module.exports = __webpack_public_path__ + "img/skanska_a_letter.16045476.jpeg";